module.exports = __webpack_public_path__ + "img/auth-page-logo.61bdff7d.png";